import { useState } from 'react';

import { ISnackbarState } from '../types';

const INITIAL_SNACKBAR_STATE: ISnackbarState = {
    open: false,
    message: '',
    variant: 'error',
};

export const useSnackbar = () => {
    const [snackbarState, setSnackbarState] = useState<ISnackbarState>(
        INITIAL_SNACKBAR_STATE
    );

    const resetSnackbarState = () => {
        setSnackbarState({ ...snackbarState, open: false });
    };

    return { snackbarState, setSnackbarState, resetSnackbarState };
};
